import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useMemo, useState } from "react";
import { faCopy, faPenToSquare, faTrashCan } from "@fortawesome/free-regular-svg-icons";
import services from "../../../../services/services";
import { Urls } from "../../../../services/Urls";
import { ToastContext } from "../../../../context/ToastContext";
import _ from "underscore";

export const useFieldConfiguration = ({ filterValues, setFilterValues }) => {
    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const [visible, setVisible] = useState({ show: false, delete: false });
    const [rowData, setRowData] = useState([]);
    const [loader, setLoader] = useState({ grid: false })
    const [fieldValues, setFieldValues] = useState({ field_configuration_id: 0 });

    useEffect(() => {
        (filterValues?.apiCall && _.isEmpty(filterValues?.config)) && getfieldConfigruation();
    }, [filterValues?.apiCall])

    const columns = [
        {
            key: "name",
            label: "Configuration name",
            style: { width: "40%" },
            render: (row) => (
                <div className="d-flex flex-column py-1 text-truncate w90">
                    <span className=" " >{row.field_configuration_name} </span>
                    <small className="text-truncate fw-semibold" >{row.field_configuration_description} </small>
                </div>
            )
        },
        {
            key: "associatedSchemes",
            label: "Associated schemes",
            style: { width: "35%" },
            render: (row) => (
                <div className="d-flex flex-column flex-wrap gap-1 py-2">
                    {
                        row?.schemes?.map((val) => {
                            return <div
                                className="text-primary bg-light text-truncate round-small-section"
                                onClick={() => setFilterValues((prev) => ({ ...prev, tab: "field_config_schemes", scheme: { field_configuration_scheme_id: val?.scheme_id, field_configuration_scheme_name: val?.scheme_name }, apiCall: true }))}
                            >
                                <FontAwesomeIcon icon="fa-solid fa-link" /> {val?.scheme_name}
                            </div>
                        })
                    }

                </div>
            )
        },
        {
            key: "actions",
            label: "Actions",
            headerStyle: { textAlign: "center" },
            style: { textAlign: "center", width: "25%" },
            render: (row) => {
                const handleAction = (isCopy = false) => {
                    const rawValue = row?.field_configuration_custom_field_ids;
                    const formattedIds = (typeof rawValue === 'string' ? rawValue.split(',') : rawValue)?.map(Number);

                    setFieldValues({
                        ...row,
                        field_configuration_id: row.field_configuration_id,
                        field_configuration_name: isCopy ? `Copy of ${row?.field_configuration_name}` : row?.field_configuration_name,
                        field_configuration_custom_field_ids: formattedIds,
                        isChange: false
                    });

                    setVisible((prev) => ({ ...prev, show: true, isCopy, row }));
                };

                return (
                    <div className="d-flex justify-content-center gap-3">
                        <FontAwesomeIcon
                            icon="fa-solid fa-sliders"
                            className="text-primary c-pointer"
                            onClick={() => {
                                setFilterValues((prev) => ({ ...prev, apiCall: true, config: row }));
                            }}
                        />
                        <FontAwesomeIcon
                            icon={faPenToSquare}
                            className="text-primary c-pointer"
                            onClick={() => handleAction(false)}
                        />
                        <FontAwesomeIcon
                            icon={faCopy}
                            className="text-gray c-pointer"
                            onClick={() => handleAction(true)}
                        />
                        <FontAwesomeIcon
                            icon={faTrashCan}
                            className="text-danger c-pointer"
                            onClick={() => setVisible((prev) => ({ ...prev, delete: true, data: row }))}
                        />
                    </div>
                );
            }
        }
    ];

    const formJson = [
        {
            label: "Field configuration name",
            name: "field_configuration_name",
            col: "12",
            type: "text",
            required: true,
        },

        {
            label: "Description",
            name: "field_configuration_description",
            col: "12",
            type: "text",
            required: false,
        },
    ]

    const getfieldConfigruation = async () => {
        try {
            setLoader({ grid: true })
            const res = await services.getInvokeRemote("GET", Urls("GETFIELDCONFIGURATIONSUMMARY"));
            if (!res?.body?.error_status) {
                const result = Object.values(res?.body?.data?.field_configuration_list?.reduce((acc, item) => {
                    const id = item.field_configuration_id;
                    if (!acc[id]) {
                        acc[id] = {
                            ...item,
                            schemes: []
                        };
                        delete acc[id].field_configuration_scheme_id;
                        delete acc[id].field_configuration_scheme_name;
                    }

                    item.field_configuration_scheme_id && acc[id].schemes.push({
                        scheme_id: item.field_configuration_scheme_id,
                        scheme_name: item.field_configuration_scheme_name
                    });

                    return acc;
                }, {}));
                setRowData(result)
            } else {
                setRowData([])
            }
        } catch (error) {
            console.error("error::", error)
        } finally {
            setLoader({ grid: false })
            setFilterValues((prev) => ({ ...prev, apiCall: false }))
        }
    }

    const handleChange = (item, e) => {
        setFieldValues((prev) => ({ ...prev, [item?.name]: e.target.value, isChange: true }));
    }

    const upsertFieldConfig = async (isDelete, ids, isfields) => {
        try {
            setLoader((prev) => ({ ...prev, btn: true }))

            let names = _.pluck(rowData, "field_configuration_name")?.map(item => item?.toLowerCase()?.trim());
            if (!_.isEmpty(visible?.row) && !visible?.isCopy) {
                names = _.filter(names, item => item !== visible?.row?.field_configuration_name?.toLowerCase()?.trim());
            }

            if (!fieldValues?.field_configuration_name?.trim() && _.isEmpty(filterValues?.config) && !isDelete) {
                showInfo("Info", "Please enter field configuration name.");
                return;
            }

            if (fieldValues?.field_configuration_name?.trim() && names?.includes(fieldValues?.field_configuration_name?.toLowerCase()?.trim()) && !isDelete && !isfields) {
                showInfo("Info", "This field configuration name is already exist.");
                return;
            }
            if ((!fieldValues?.isChange || (fieldValues?.isChange && _.isEmpty(filterValues?.config) && visible?.row?.field_configuration_name?.trim() === fieldValues?.field_configuration_name?.trim() && visible?.row?.field_configuration_description?.trim() === fieldValues?.field_configuration_description?.trim())) && !isDelete && !visible.isCopy) {
                showInfo("info", "No changes made.");
                return;
            }

            let payload
            let url
            if (visible.isCopy) {
                url = "UPSERTFIELDCONFIGURATIONCOPY"
                payload = {
                    "source_field_configuration_id": fieldValues?.field_configuration_id || 0,
                    "new_configuration_name": fieldValues?.field_configuration_name || "",
                    "new_configuration_description": fieldValues?.field_configuration_description || ""
                }
            } else {
                url = "UPSERTFIELDCONFIGURATION"
                payload = {
                    "field_configuration_id": isDelete ? visible?.data.field_configuration_id : !_.isEmpty(filterValues?.config) ? filterValues?.config.field_configuration_id : fieldValues?.field_configuration_id || 0,
                    "field_configuration_name": filterValues?.config?.field_configuration_name || fieldValues?.field_configuration_name || "",
                    "field_configuration_description": filterValues?.config?.field_configuration_description || fieldValues?.field_configuration_description || "",
                    "field_configuration_customfield_ids": ids?.toString() || "",
                    "is_deleted": isDelete || false
                }
            }

            const res = await services.getInvokeRemote("POST", Urls(url), payload);
            if (!res?.body?.error_status) {
                showSuccess('Sucess', res.body.message)
                if (isDelete) {
                    setRowData(prevData =>
                        prevData.filter(item => item.field_configuration_id !== visible?.data.field_configuration_id)
                    );
                } else {
                    setFieldValues((prev) => ({ isChange: false, field: [] }))
                    setFilterValues((prev) => ({ ...prev, apiCall: true }))
                }
                setVisible((prev) => ({ ...prev, show: false, delete: false, isCopy: false }))
            } else {
                showError("Error", res.body.message);
            }
        } catch (error) {
            error?.response?.data?.errorMessage && showError("Error", error?.response?.data?.errorMessage);
            console.error("error::", error)
        } finally {
            setLoader((prev) => ({ ...prev, btn: false }))
        }
    }

    const filteredData = useMemo(() => {
        if (!filterValues?.search?.trim()) return rowData;

        return rowData?.filter((item) =>
            item?.field_configuration_name
                ?.toLowerCase()
                .includes(filterValues?.search.toLowerCase())
        );
    }, [rowData, filterValues?.search]);

    return {
        columns, rowData: filteredData, visible, setVisible, fieldValues, setFieldValues, handleChange, formJson, upsertFieldConfig, loader
    }
}